import { z } from 'zod';

const ORDER_BY_OPTIONS = [
  'created_at:asc', 'created_at:desc',
  'power:asc', 'power:desc',
] as const;

export const microInverterFiltersSchema = z.object({
  brand: z.string().max(100).optional(),
  is_enabled: z.boolean().optional(),
  is_hybrid: z.boolean().optional(),
  model: z.string().max(100).optional(),
  order_by: z.enum(ORDER_BY_OPTIONS).optional(),
  power: z.number().min(0.1).max(999).optional(),
  sku: z.string().max(100).optional(),
});

export type MicroInverterFiltersFormData = z.infer<typeof microInverterFiltersSchema>;
